import { StrictMode, Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import './accessibility.css';
import './i18n/config';
import App from './app/App';
import { initializeSentry } from './bootstrap/sentrySetup';
import * as Sentry from '@sentry/react';

// Error fallback component for Sentry ErrorBoundary
function ErrorFallback() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Something went wrong</h1>
      <p>We've been notified and are working to fix the issue.</p>
      <button type="button" onClick={() => window.location.reload()}>Reload page</button>
    </div>
  );
}

// Initialize error tracking
initializeSentry()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog>
    <StrictMode>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </StrictMode>
  </Sentry.ErrorBoundary>
);
